import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useMountEffect } from '@react-hookz/web';
import { Breakpoint } from '@travel-frontend/core';
import { AccountControl } from '../../components/AccountControl/AccountControl.js';
import { CountrySwitchDesktop, CountrySwitchMobile } from '../../components/CountrySwitch/index.js';
import { HeaderFavorite } from '../../components/HeaderFavorite/index.js';
import { Container, Controls, HeaderControl } from '../../components/HeaderNew/components/index.js';
import { LogoContainer } from '../../components/HeaderNew/components/LogoContainer.js';
import { Container as HotlinePlaceholder } from '../../components/HotlineBarNew/components/Container.js';
import { HotlineBarNew } from '../../components/HotlineBarNew/HotlineBarNew.js';
import { LoginControl } from '../../components/LoginControl/LoginControl.js';
import LogoSection from '../../components/LogoSection/index.js';
import { Menu } from '../../components/Menu/index.js';
import { MobileMenu } from '../../components/MobileMenu/index.js';
import { SslWidget } from '../../components/SslWidget/index.js';
import { useAuthentication } from '../../hooks/index.js';
import { Flex, Grid, GridItem, HeadlineSmall } from '../../primitives/index.js';
import { HEADER_QA_ID, qaId } from '../../utils/qaId.js';
export const HeaderNew = ({
  config,
  path = '',
  title,
  onLoginClick,
  onLogoutClick,
  onFavoriteClick
}) => {
  const {
    getUserStatus
  } = useAuthentication();
  useMountEffect(() => {
    getUserStatus();
  });
  return _jsxs(Container, {
    "data-cy": qaId(HEADER_QA_ID),
    "data-testid": qaId(HEADER_QA_ID),
    children: [config?.hotline ? _jsx(HotlineBarNew, {
      config: config.hotline
    }) : _jsx(HotlinePlaceholder, {}), _jsx(Breakpoint, {
      matches: ['xs', 'sm', 'md'],
      children: _jsxs(Flex, {
        justifyContent: "space-between",
        alignItems: "center",
        direction: "row",
        style: {
          minHeight: '3.5rem'
        },
        children: [config && _jsx(LogoContainer, {
          children: _jsx(LogoSection, {
            logoConfig: config.logo,
            pageType: config.pageType,
            path: path
          })
        }), title && _jsx(HeadlineSmall, {
          whiteSpace: "nowrap",
          color: "contentInversePrimary",
          children: title
        }), _jsxs(Controls, {
          children: [_jsxs(HeaderControl, {
            children: [config?.favouriteList && _jsx(HeaderFavorite, {
              onClick: onFavoriteClick
            }), config?.login && (config?.pageType === 'book' ? _jsx(LoginControl, {
              hideLabelBreakpoint: config?.menu?.items ? 'special' : 'lg',
              onLogoutClick: () => onLogoutClick?.(),
              onLoginClick: () => onLoginClick?.()
            }, "AccountControl") : _jsx(AccountControl, {})), config?.sslIcon && _jsx(SslWidget, {})]
          }), config?.menu && _jsx(MobileMenu, {
            config: config.menu.items,
            additionalItems: config.countrySwitch && _jsx(CountrySwitchMobile, {
              countrySwitchData: config.countrySwitch
            })
          })]
        })]
      })
    }), _jsx(Breakpoint, {
      matches: ['lg', 'xl'],
      children: _jsx(Flex, {
        justifyContent: "center",
        direction: "row",
        style: {
          minHeight: '4rem'
        },
        children: _jsxs(Grid, {
          xs: 4,
          sm: 4,
          md: 8,
          lg: 12,
          xl: 12,
          children: [_jsx(GridItem, {
            xs: 1,
            sm: 1,
            md: 2,
            lg: 2,
            xl: 2,
            children: config && _jsx(LogoSection, {
              logoConfig: config.logo,
              pageType: config.pageType,
              path: path
            })
          }), _jsx(GridItem, {
            lg: 7,
            xl: config?.menu?.items ? 7 : 6,
            children: config?.menu?.items && _jsx(Menu, {
              config: config.menu.items
            })
          }), _jsx(GridItem, {
            lg: 3,
            xl: config?.menu?.items ? 3 : 4,
            children: _jsxs(Controls, {
              children: [config?.countrySwitch && _jsx(CountrySwitchDesktop, {
                countrySwitchData: config.countrySwitch
              }), config?.favouriteList && _jsx(HeaderFavorite, {
                onClick: onFavoriteClick
              }), config?.login && (config?.pageType === 'book' ? _jsx(LoginControl, {
                hideLabelBreakpoint: config?.menu?.items ? 'special' : 'lg',
                onLogoutClick: () => onLogoutClick?.(),
                onLoginClick: () => onLoginClick?.()
              }, "AccountControl") : _jsx(AccountControl, {})), config?.sslIcon && _jsx(SslWidget, {})]
            })
          })]
        })
      })
    })]
  });
};